/* @flow */
import workflow from './workflow';
import { review } from 'ducks/workflow';
import ReviewButton from 'components/buttons/workflow/ReviewButton';

export default workflow({action: review})(ReviewButton);
